import PropTypes from 'prop-types';
import CatalogBrowser from '@/components/catalog/CatalogBrowser';
import SeoHead from '@/components/SeoHead';
import { fetchProductsAdmin } from '@/lib/firebaseAdmin';
import { productPropType } from '@/lib/propTypes';

export default function ProductsIndexPage({ products = [] }) {
  return (
    <main className="space-y-10 px-4 py-10 md:px-6">
      <SeoHead
        title="Products | Trendy Quest Collection Kenya"
        description="Browse Trendy Quest departments, move through subdivisions, and open the exact product you want."
        path="/products"
      />
      <CatalogBrowser products={products} />
    </main>
  );
}

ProductsIndexPage.propTypes = {
  products: PropTypes.arrayOf(productPropType),
};

export async function getStaticProps() {
  return {
    props: {
      products: await fetchProductsAdmin(),
    },
    revalidate: 60,
  };
}
